import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Source from './Source';

class Sources extends Component {
  static propTypes = {
    encodings: PropTypes.array
  };
  render() {
    const { encodings } = this.props;
    return Array.isArray(encodings)
      ? encodings.map((encoding, i) => {
        return <Source encoding={encoding} key={i} />;
      })
      : null;
  }
}

export default Sources;



// WEBPACK FOOTER //
// ./src/components/Steps/Sources.js